import { Button, FormControl, FormLabel, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select } from "@chakra-ui/react";
import RangeDatepicker from "components/datepicker/range-date-picker";
import { Field, Form, Formik } from "formik";
import { FC, ReactElement, useEffect, useState } from "react";
import ReportService from "../../services/reports/report-service";

const formInitialValue = {
    status: 0
};

interface DownloadReportDialogProps {
    onClose: any
};

const DownloadReportDialog: FC<DownloadReportDialogProps> = ({ onClose }) => {
    const [formValue, setFormValue] = useState<any>(formInitialValue);
    const [isSubmiting, setIsSubmiting] = useState<boolean>(false);
    const [selectedDates, setSelectedDates] = useState<Date[]>([new Date(), new Date()]);

    useEffect(() => {
        var today = new Date();
        var startDate = new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0);
        var lastDate = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
        var endDate = new Date(today.getFullYear(), today.getMonth(), lastDate, 23, 59, 59);

        setSelectedDates([startDate, endDate]);
    }, []);

    const handleFormSubmit = (values: any) => {
        setIsSubmiting(true);
        ReportService.DownloadSalesReportExcel(values.status, selectedDates[0].toDateString(), selectedDates[1].toDateString()).then((res: any) => {
            const downloadUrl = window.URL.createObjectURL(new Blob([res]));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', 'Sales Report.xlsx'); //any other extension
            document.body.appendChild(link);
            link.click();
            link.remove();
        }).finally(() => {
            setIsSubmiting(false);
        })
    };

    return (
        <Modal isOpen={true} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <Formik initialValues={formValue} onSubmit={handleFormSubmit}>
                    {
                        ({ handleSubmit, errors, touched, setFieldValue }) => (
                            <Form onSubmit={handleSubmit} noValidate={true}>
                                <ModalHeader textAlign={"center"}>Download Laporan Penjualan</ModalHeader>
                                <ModalBody pt={5}>

                                    <FormControl isRequired>
                                        <FormLabel htmlFor='logosBankAccountId'>Status Order</FormLabel>
                                        <Field
                                            as={Select}
                                            id='status'
                                            placeholder='Status Order'
                                            name={'status'}
                                        >
                                            <option value={0}>Semua</option>
                                            <option value={10}>Belum Bayar</option>
                                            <option value={20}>Belum Lunas</option>
                                            <option value={30}>Lunas</option>
                                            <option value={40}>Batal</option>
                                        </Field>
                                    </FormControl>

                                    <FormControl isRequired mt={4}>
                                        <FormLabel htmlFor='bankName'>Pilih Tanggal</FormLabel>
                                        <RangeDatepicker selectedDate={selectedDates} setSelectedDates={setSelectedDates} />
                                    </FormControl>

                                </ModalBody>
                                <ModalFooter>
                                    <Button variant={'outline'} mr={3} onClick={onClose}>
                                        Kembali
                                    </Button>
                                    <Button type={'submit'} isLoading={isSubmiting}>Download Sekarang</Button>
                                </ModalFooter>
                            </Form>
                        )
                    }
                </Formik>
            </ModalContent>
        </Modal>
    );
};

export default DownloadReportDialog;